import React from "react";

const ScreenMetric = ({ label, value, detail }) => {
  return (
    <article className="new-hrm-screen-metric">
      <span>{label}</span>
      <strong>{value}</strong>
      <small>{detail}</small>
    </article>
  );
};

export default ScreenMetric;
